import produce from "immer";
import * as types from "./actionTypes";
// Change This To Activity, Badges, Statistis
import { Feedback } from "@shelter/core/dist/models";

export interface MyWorkReducer {
  activity: Feedback[];
  loading: boolean;
  loadingMore: boolean;
  canLoadMore: boolean;
}

const initial = {
  activity: [] as Feedback[],
  loading: false,
  loadingMore: false,
  canLoadMore: false,
} as MyWorkReducer;

export const myWorkReducer = (state = initial, action: any) =>
  produce(state, (draft) => {
    switch (action.type) {
      case types.GET_ACTIVITY_REQUEST:
        break;
      case types.UPDATE_LIST_ACTIVITY:
        draft.activity = [...draft.activity, ...action.activity];
        break;
      case types.SET_LOADING:
        draft.loading = action.loading;
        break;
      case types.SET_LOADING_MORE:
        draft.loadingMore = action.loadingMore;
        break;
      case types.SET_CAN_LOAD_MORE:
        draft.canLoadMore = action.canLoadMore;
        break;
      case types.CLEAR_ACTIVITY:
        draft.activity = [];
        draft.loading = false;
        draft.loadingMore = false;
        draft.canLoadMore = false;
        break;
      default:
        return draft;
    }
    return draft;
  });
